var _path, _path2, _path3, _path4, _path5, _rect, _path6, _circle, _circle2, _circle3, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle4, _path17, _path18, _polygon, _path19, _polygon2, _path20, _circle5, _path21, _path22, _polygon3, _path23, _circle6, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 846.54724,
    height: 604.04724,
    viewBox: "0 0 846.54724 604.04724",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.30511,697.32729l-16.15689,14.87434,12.84025-21.54491c-10.11622-18.345-26.6612-34.19959-26.6612-34.19959s-34.32506,32.88613-34.32506,58.73676S212.37,750.0706,231.32727,750.0706c18.957,0,34.32476-9.02607,34.32476-34.87671C265.652,709.44007,263.94905,703.338,261.30511,697.32729Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.99312,713.00688v1.27419c-.07569,14.81124-2.57364,26.36752-7.475,34.50483-.06938.11985-.14508.23339-.21449.35325l-.5488-.33431-.52353-.328c5.4375-8.78705,7.36143-21.20753,7.43081-34.12632.00632-.41635.01263-.839.00632-1.2616-.019-5.46907-.35325-11.00117-.88942-16.37561-.03784-.41635-.082-.839-.12616-1.2616-.74434-7.0902-1.81671-13.865-2.9143-19.75038-.0757-.41635-.1577-.83266-.23971-1.2427-1.89872-9.954-3.83528-17.16407-4.27685-18.76-.05044-.19554-.082-.30277-.08832-.328l.59927-.17033.00631-.00631.60559-.17033c.00631.02526.11353.38482.29014,1.05347.675,2.49795,2.42861,9.27906,4.15068,18.22381.07569.40372.1577.82007.23339,1.23638.89573,4.77517,1.77255,10.11176,2.46646,15.71324q.2649,2.11006.4731,4.16331c.05043.42263.0946.84525.13244,1.2616Q240.96164,705.39,240.99312,713.00688Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.78569,674.3009c-.42263.05679-.85157.11358-1.28682.1577a34.80018,34.80018,0,0,1-3.55773.183,33.85111,33.85111,0,0,1-14.63459-3.30539c-.26492.3343-.52985.66864-.80109,1.00926a35.10444,35.10444,0,0,0,15.43568,3.55773,36.00641,36.00641,0,0,0,3.79744-.20186c.42894-.04416.85788-.10095,1.2805-.164a34.8086,34.8086,0,0,0,10.06129-3.04678q-.40686-.5204-.79482-1.02189A33.73488,33.73488,0,0,1,236.78569,674.3009Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.95864,695.41383q-.65289.03783-1.30576.03785c-.13249.00631-.27124.00631-.40373.00631a34.03065,34.03065,0,0,1-27.93189-14.59043c-.25229.37215-.50463.74434-.75061,1.12281a35.29427,35.29427,0,0,0,28.6825,14.72922c.17665,0,.35325,0,.52989-.00631.44153-.00631.87679-.01894,1.312-.03785a35.10765,35.10765,0,0,0,18.70327-6.56034c-.20186-.37215-.40372-.74434-.6119-1.11649A33.797,33.797,0,0,1,239.95864,695.41383Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.99312,713.00688c-.44153.03785-.8831.06307-1.32466.082-.4731.0189-.94621.03153-1.41931.03153a34.12271,34.12271,0,0,1-32.71333-24.5508c-.28387.511-.56774,1.01562-.839,1.52656A35.37227,35.37227,0,0,0,238.24915,714.382c.4731,0,.94621-.00631,1.413-.03153.44788-.01263.88945-.03785,1.331-.06942a35.26879,35.26879,0,0,0,23.27658-11.36073c-.13249-.46679-.28387-.92726-.43526-1.394A34.01258,34.01258,0,0,1,240.99312,713.00688Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 536.54724,
    y: 76.24301,
    width: 310,
    height: 187.80423,
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.05709,183.97638h-432a1,1,0,0,1,0-2h432a1,1,0,0,1,0,2Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#cacaca"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 431.83858,
    cy: 11,
    r: 11,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.83858,
    cy: 11,
    r: 11,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.83858,
    cy: 11,
    r: 11,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M890.28768,315.83164l-18.87024-19.44758a4.28923,4.28923,0,0,0-3.15443-1.2674h-.05631a4.28924,4.28924,0,0,0-3.15444,1.2674l-18.87019,19.44758a4.16424,4.16424,0,0,0-.19777,5.88577q.09551.1022.19777.19777a4.6579,4.6579,0,0,0,6.36518,0l11.1813-11.68826v30.136a4.51083,4.51083,0,0,0,9.01265,0v-30.136l11.1813,11.68826a4.6579,4.6579,0,0,0,6.36518,0,4.16424,4.16424,0,0,0,.19777-5.88577Q890.38995,315.92722,890.28768,315.83164Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M868.27362,364.45748a44.28571,44.28571,0,1,1,44.28572-44.28571A44.33581,44.33581,0,0,1,868.27362,364.45748Zm0-86.93121a42.6455,42.6455,0,1,0,42.6455,42.6455A42.69385,42.69385,0,0,0,868.27362,277.52627Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a4df8293-127a-4fe1-b900-32b0737a0281-370",
    "data-name": "Path 138",
    d: "M892.91194,512.33648H603.37867c-2.95927-.00753-5.35792-4.91324-5.36168-10.97033V354.41189c0-6.05586,2.40241-10.96026,5.36168-10.97033H892.91194c2.95927.00753,5.35791,4.91324,5.36168,10.97033V501.36484C898.26985,507.4207,895.86736,512.32887,892.91194,512.33648Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f5addd83-a4bf-4cbc-bc49-a1c93dc12b76",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b85ea7ab-2687-4539-bc87-5f9af2589fda",
    "data-name": "Ellipse 7",
    cx: 519.76653,
    cy: 253.64768,
    r: 25.31818,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a93bdb3c-c63a-46e2-832f-5ad698cb7678-371",
    "data-name": "Path 63",
    d: "M775.88793,479.64341H651.68564a2.54194,2.54194,0,0,1-.46362-.03779L709.96645,377.858a4.112,4.112,0,0,1,7.15945,0l39.42288,68.28111,1.8897,3.26664Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e75948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9a16db8-129a-402e-ab5a-cd8e8637e69a-372",
    "data-name": "Path 65",
    d: "M845.03958,479.64468H737.614l20.81567-30.23517,1.4979-2.1782,27.126-39.404a5.4889,5.4889,0,0,1,8.1534-.48627,4.90238,4.90238,0,0,1,.39053.48627Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e75948"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "e7d95ff1-9828-4401-a808-15868bd1799b-373",
    "data-name": "Path 138",
    d: "M892.91194,512.33648H603.37867c-2.95927-.00753-5.35792-4.91324-5.36168-10.97033V354.41189c0-6.05586,2.40241-10.96026,5.36168-10.97033H892.91194c2.95927.00753,5.35791,4.91324,5.36168,10.97033V501.36484C898.26985,507.4207,895.86736,512.32887,892.91194,512.33648ZM603.37867,347.8294c-1.77629,0-3.215,2.94919-3.21755,6.58242v146.953c0,3.63322,1.44119,6.57865,3.21755,6.58242H892.91194c1.77628,0,3.215-2.948,3.21755-6.58242V354.41189c0-3.63322-1.44119-6.57865-3.21755-6.58241Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M558.72638,752.02362h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#cacaca"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M444.678,355.33838c-9.41608-13.25983-28.045-13.87775-28.045-13.87775s-18.15284-1.93469-29.79779,18.2602c-10.854,18.8233,4.4392,42.221,4.4392,42.221,3.02259.18116,16.09125.2602,54.9831-4.54467L448,388l4.999,8.56958c2.07831-.25366,4.23993-.51617,6.49939-.78906C458.47583,385.80829,453.73828,368.09705,444.678,355.33838Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.87379,540.86383l-2.49447-85.80631-16.98312,7.42991,8.19475,79.306a10.3713,10.3713,0,1,0,11.28284-.92958Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M444.74291,466.20233c11.07558,1.0716,19.03091-3.50375,24.41264-12.737l-3.715-17.01069a26.03067,26.03067,0,0,0-18.192-24.8224l-1.97494-.62367Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352.3545,442.6079a2.097,2.097,0,0,1-.43242-.04488l-20.48815-.34581-.045-.50939.00083-.022,1.69993-42.21536a3.28652,3.28652,0,0,1,3.42961-3.13851l16.41056.73184a3.28624,3.28624,0,0,1,3.13676,3.42945l-1.61455,40.09765a2.10225,2.10225,0,0,1-2.0976,2.017Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e75948"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M350.12148,442.63783c-.05237,0-.10465-.00133-.15727-.00366l-16.08712-.71721a3.45253,3.45253,0,0,1-3.29138-3.59869l1.71847-38.54552a3.29005,3.29005,0,0,1,3.42961-3.13651l16.41048.73151a3.29044,3.29044,0,0,1,3.13684,3.42978l-1.71846,38.54552a3.44892,3.44892,0,0,1-3.44117,3.29478Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.19218,
    cy: 258.72768,
    r: 2.34934,
    fill: "#e75948"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M362.44883,453.09664V468.591l-14.9682-23.58637a9.77173,9.77173,0,1,0-9.5069,4.78l20.92388,37.07493a10.42355,10.42355,0,0,0,19.45564-4.15008l2.589-27.61339Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M382.94133,465.09243c-10.43091,1.00922-17.92318-3.29981-22.99166-11.99565l3.49873-16.02055a24.51552,24.51552,0,0,1,17.13313-23.37757l1.86-.58737Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230.398 594.758 218.985 592.906 220.697 548.005 237.541 550.738 230.398 594.758",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M409.6879,751.36194l-37.28015.0373-.00049-.47154a14.51125,14.51125,0,0,1,14.49542-14.52529h.00092l22.76945-.0227Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "284.937 568.612 274.614 573.82 249.614 536.483 264.849 528.797 284.937 568.612",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M469.34447,725.26534l-33.28366,16.79313-.21242-.421a14.51127,14.51127,0,0,1,6.418-19.49132l.00082-.00041,20.32856-10.25661Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.6279,
    cy: 229.7961,
    r: 20.29501,
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.515,357.31423l-18.40429-9.64076-25.41586,3.94409-5.25837,23.225c25.95627,3.73263,43.922,5.87356,49.95508-.43829Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M382.62244,504.67815s-15.47116,31.642,1.6705,78.46533L431.6403,703.87441l22.63509-13.3808-23.07282-51.9772,18.76808-63.62147a110.57052,110.57052,0,0,0,3.91542-44.5187c-1.35257-11.188-4.49188-22.56581-11.3203-28.30168C426.4989,488.57839,382.62244,504.67815,382.62244,504.67815Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.778 481.348 214.613 568.374 237.473 572.684 251.854 497.356 231.778 481.348",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M430.32343,407.97656l-26.23983.34978L381.11443,413.61l1.36126,91.99931s41.52842,11.74949,59.76874-4.49873l12.03115-86.10746C447.5246,411.1875,439.41815,408.99094,430.32343,407.97656Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#e4e4e4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.27362,
    cy: 196.02362,
    r: 13,
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M415,341a12.99324,12.99324,0,0,1,15.53748-12.74847,12.99389,12.99389,0,1,0-8.075,24.49694A12.989,12.989,0,0,1,415,341Z",
    transform: "translate(-176.72638 -147.97638)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.5e1afebdf25f94e9d9937b390aed16dd.svg";
export { ForwardRef as ReactComponent };